"use client";

import { ROOT_PATH } from "@/config/constants";
import { isDev } from "@/config/env";
import { Button } from "@/shared/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="en">
      <body className="antialiased">
        <main
          data-testid="global-error-card"
          className="flex h-screen items-center justify-center p-4 sm:p-8"
        >
          <Card className="w-full max-w-sm sm:max-w-md">
            <CardHeader>
              <CardTitle>Unexpected Error Occurred</CardTitle>
              <CardDescription>{error.digest}</CardDescription>
            </CardHeader>
            {isDev && error.stack && (
              <CardContent>
                <pre className="whitespace-pre-wrap break-all text-xs text-muted-foreground">
                  {error.stack}
                </pre>
              </CardContent>
            )}
            <CardFooter>
              <Button onClick={reset}>Try Again</Button>
              <Button asChild>
                <a href={ROOT_PATH}>Return to Home</a>
              </Button>
            </CardFooter>
          </Card>
        </main>
      </body>
    </html>
  );
}
